import React, { useEffect, forwardRef } from 'react'

import { init } from './app'

import useSharedRef from 'src/components/useSharedRef'

const Waves = ({ config, preserveDrawingBuffer }, ref) => {
  const canvas = useSharedRef(ref)

  useEffect(() =>
    init(canvas.current, config, preserveDrawingBuffer)
  , Object.values(config))

  return <canvas ref={canvas} className="w-100 h-100 position-absolute" />
}

export default forwardRef(Waves)
